<template lang="html">
  <v-dialog
    v-model="dialog"
    persistent
    max-width="800px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn        
        v-on="on"
      >
        BIC Change
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      class="mb-0"
    > 
      <template v-slot:header>
        <v-card-title>
          <div class="px-2">
            <h4 class="title font-weight-light">
              {{ branch.branch_name }}
            </h4>
            <p class="category font-weight-thin">
              BIC Change
            </p>
          </div>
          <v-spacer />
          <v-btn  
            text
            icon 
            color="white"
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
      </template>

      <v-row>
        <v-col>
          <div 
            class="mb-12 overflow" 
            data-simplebar
          >
            <setup-branch-form-cro-promotion-same-branch
              v-show="bottomNav==='internal'" 
              :users="users"
              @close-dialog="closeDialog(true)"
            />

            <setup-branch-form-cro-promotion-different-branch 
              v-show="bottomNav==='external'"
              :users="users" 
              @close-dialog="closeDialog(true)"
            />

            <setup-branch-form-bic-transfer
              v-show="bottomNav==='transfer'"
              :users="users" 
              @close-dialog="closeDialog(true)"
            />
          </div>
        </v-col>
        
        <v-bottom-navigation
          v-model="bottomNav"
          :value="true"
          absolute
          color="transparent"
        >
          <v-btn
            color="teal"
            text
            value="internal"
          >
            <span>Internal</span>
            <v-icon>mdi-arrow-up</v-icon>
          </v-btn>

          <v-btn
            color="teal"
            text
            value="external"
          >
            <span>External</span>
            <v-icon>mdi-history</v-icon>
          </v-btn>

          <v-btn
            color="teal"
            text
            value="transfer"
          >
            <span>Transfer</span>
            <v-icon>mdi-account-switch</v-icon>
          </v-btn>
        </v-bottom-navigation>
      </v-row>
    </material-card>
  </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    components: {
      SetupBranchFormCroPromotionSameBranch: () => import('@/components/setup/branch/FormCroPromotionSameBranch'),
      SetupBranchFormCroPromotionDifferentBranch: () => import('@/components/setup/branch/FormCroPromotionDifferentBranch'),
      SetupBranchFormBicTransfer: () => import('@/components/setup/branch/FormBicTransfer'),
    },
    inject: ['$validator'],
    props: {

    },
    data () {
      return {
        bottomNav: 'internal',
        dialog: false,
        users: [],      
      }
    },
    computed: {
      ...mapGetters({
        branch: 'branch/currentBranch',
      }),
    },
    mounted () {
      this.$http.all([
        this.$api.users().list(),
        
      ])
        .then(this.$http.spread((users) => {        
          this.users = users.data
        }))
    },
    methods: {
      emitRefreshBranch () {
        this.$emit('refresh-branch')
      },   
      setProgressing (value = false) {
        this.progressing = value
      },
      closeDialog (refresh = false) {
        this.dialog = false
        if (refresh === true) {
          this.emitRefreshBranch()
        }
      },
    
    },
  }
</script>

<style lang="css" scoped>
  .overflow {
    height:40vh;
  }
</style>
